export default __webpack_public_path__ + "static/media/pp.652bcfcc.jpeg";